import { LazyAppModals } from "@faire/retailer/components/App/AppModals";

import { preload } from "./__internal__/preload";

const preloadAppModals = () => {
  preload(LazyAppModals);
};

export default preloadAppModals;
